import useSWR from 'swr';
import { ApiError } from '@/service/ApiError';
import { HTTP_STATUS_CODE } from '@/service/constants';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '@/service/fetcher/monitoringToolService';
import { MarketRelatedActionType } from '@/contexts/markets/types';
import { useAuthToken } from '@/contexts/auth/useAuthToken';

export const useSwitchMarketActionTypesConfig = () => {
  const token = useAuthToken();
  const { data, error } = useSWR<MarketRelatedActionType[], ApiError>(
    token
      ? {
          token,
          endpoint:
            SERVICE_ENDPOINT.Configurations().SwitchMarketActionTypesConfig.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status === HTTP_STATUS_CODE.NOT_FOUND ||
          e.status === HTTP_STATUS_CODE.UNAUTHORIZED
        )
          return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    error: error,
    isLoading: !data && !error,
    marketRelatedActionTypes: data,
  };
};
